import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class TopCardApi extends ComponentAPI {
}
export default TopCardApi;
//# sourceMappingURL=top-card-api.js.map